import mode from "./modeReducer";
import baseTable from "./baseTableReducer";
import activeStageIdx from "./activeStageIdxReducer";
import keywords from "./keywordsReducers";
import queryModel from "./queryModelReducer";
import organizationID from "./organizationIDReducer";
import tableHash from "./tableHash";
import lastExecutedStage from "./lastExecutedStageReducer";
import qid from "./qidReducer";

export default {
	mode,
	baseTable,
	activeStageIdx,
	keywords,
	queryModel,
	organizationID,
	tableHash,
	lastExecutedStage,
	qid
};
